<template>
    <div>
        <!-- 评估完成 -->
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" class="event-form">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="下一节点">
                        <span>{{ title ? title : '问题分析与评估'}}</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="处理组" prop="currentDepartment">
                        <el-select v-model="form.currentDepartment" filterable placeholder="请选择" @change="departmentChange">
                            <el-option v-for="item in departmentList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                        <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="处理人" prop="currentHandler">
                        <div class="el-form__inline">
                            <el-input v-model="form.currentHandler" disabled></el-input>
                            <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="dis_user" @click="toRequesterList"></el-button>
                            <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--<el-row :span="12" v-if="title">-->
                <!--<el-form-item label="完成程度" prop="completionDegree">-->
                    <!--<el-select v-model="form.completionDegree" placeholder="请选择">-->
                        <!--<el-option v-for="item in completionDegree" :key="item.id" :label="item.cname"-->
                                   <!--:value="item.id"></el-option>-->
                    <!--</el-select>-->
                <!--</el-form-item>-->
            <!--</el-row>-->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="处理意见" prop="handleComment">
                        <el-input type="textarea" v-model="form.handleComment"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item label="知会" >
                <div class="el-form__inline">
                    <notifyTab :data="form.notify" :getData="getNotifyData"></notifyTab>
                    <router-link :to="{ path:'/requesterList',query: { callback:getNoticer,moreSelect:true } }">
                        <span  class="noticeAdd">+</span>
                    </router-link>
                </div>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import services from "./problem.service"
    import commonService from "../../services/common.service"
    import notifyTab from "../common/notifyTab.vue"
    import { getRules } from "./problem.rules";
    const rules = getRules();
    export default {

        props:{
            callback:Function,
            serialNumber:String,
            title:String,
        },
        data() {
            return {
                rules:rules,
                form:{
                    currentDepartment:"",
                    currentHandler:'',
                    handleComment:"",
                    notify:[]
                },
                notifyUserid:[],
                departmentList:[],   // 处理组
                requesterInfo:{},
                // requesterName:"",
                // requesterId:"",
                dis_user:true,
                groupTasksTotal:'',   //组任务数
                userTasksTotal:'',    //人员任务数量
                isSubmit:false
            }
        },
        components:{
            notifyTab
        },

        created() {
            this.getDepartment();
            if(this.title){
                this.$modal.title = "实施解决方案";
            }
            // console.log(this.dictionary);
        },
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            completionDegree(){
                return this.dictionary.completion_degree
            }
        },
        methods: {
            // 服务组
            getDepartment(){
                let params= {
                    departmentId:99999,
                    type:'group'
                }
                commonService.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;
                    // console.log(this.departmentList);

                })
            },
            departmentChange(){
                this.dis_user = this.form.currentDepartment ? false : true;
                this.form.currentHandler = ''; //选择处理组后清空处理人
                this.userTasksTotal= '';
                this.requesterInfo = {
                    id:"",
                    name:"",
                };
                let groupId=this.form.currentDepartment
                this.getGroupBusyness(groupId)
            },
            getGroupBusyness(id){
                services.busynessGroup(id).then(res => {
                    this.groupTasksTotal = res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            toRequesterList(){
                let id = this.form.currentDepartment.toString();
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:id
                    }
                })
            },
            // 获取选择的组员
            getRequester(obj){
                this.requesterInfo = {
                    id:obj.internalUserid,
                    name:obj.name,
                };
                this.form.currentHandler = obj.name;

                let userid=this.requesterInfo.id
                this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },

            submit(){
                this.isSubmit=true
                this.notifyUserid=this.form.notify&&this.form.notify.map(item=>{return item.userid})
                let handle = this.title ?'实施解决方案':'分析评估';
                let params = {
                    ...this.form,
                    currentHandler:this.requesterInfo.id,
                    handle:handle,
                    serialNumber:this.serialNumber,
                    notify:this.notifyUserid
                };
                // if (!params.currentDepartment) {
                //     this.isSubmit=false
                //     this.$message.error('请选择处理组')
                // }else if (!params.currentHandler){
                //     this.isSubmit=false
                //     this.$message.error('请选择处理人')
                // } else if(!params.handleComment){
                //     this.isSubmit=false
                //     this.$message.error('请填写处理意见')
                // }else{
                //     services.handle(params).then(res => {
                //         this.$message.success('实施解决方案成功');
                //         this.close(true);
                //     }).catch(err => {
                //         this.isSubmit=false
                //         this.$message.error(err.message)
                //     })
                // }
                this.$refs['form'].validate(valid=>{
                    if (valid){
                            services.handle(params).then(res => {
                                this.$message.success(handle+'成功');
                                this.close(true);
                            }).catch(err => {
                                this.isSubmit=false
                                this.$message.error(err.message)
                            })
                    } else {
                        this.isSubmit=false
                        this.$message.error('错误')
                    }
                })

            },
            //将选择的知会人信息去重保存
            getNoticer(obj){
                this.form.notify=this.arrayUnique(this.form.notify.concat(obj))
            },
            //删除后显示剩余的知会人
            getNotifyData(val){
                this.form.notify=val
            },
            //选择完知会人后去重，此方法可通用于包含对象的数组深层次去重
            arrayUnique(arr){
                let obj={}
                let newArr = []
                arr.forEach(item=>{
                    if(!obj[item.id]){
                        obj[item.id]=1
                        newArr.push(item)
                    }
                })
                return newArr

            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .noticeAdd{
        color: #1890ff;
        font-size: 27px;
        position: relative;
        top: -2px;
        margin-left: 10px;
    }
</style>
